import ListUser from "../../components/admin/users/ListUser";
import Admin from "../Admin";

const Users = () => {
    return ( 
        <Admin>
            <ListUser/>
        </Admin>
    );
}
 
export default Users;